import Vue from "vue"
import VueRouter from 'vue-router'
import list from './list'
import echarts from 'echarts'
// require styles 引入样式
// import 'quill/dist/quill.core.css';
// import 'quill/dist/quill.snow.css';
// import 'quill/dist/quill.bubble.css';
Vue.prototype.$echarts = echarts
Vue.use(VueRouter);

const router = new VueRouter({
    // mode: process.env.NODE_ENV === 'production'?'history':'hash',
    mode:'history',
    base:process.env.NODE_ENV === 'production'?'/':"/",
    routes: [
        list,
        {
            path: "/",
            redirect: "/login"
        },
        {
            path: "/login",
            name: "login",
            component: () => import("@pages/login")
        },
        {
            path: "/changeFactory",
            name: "changeFactory",
            component: () => import("@pages/changeFactory")
        },
        // 数据库验证
        {
            path: "/dbverify",
            name: "dbverify",
            component: () => import("@pages/dbverify")
        }
    ],
    icons:{
        "energy":"icon-data",
        "realtime":"icon-wendang",
        "all":"icon-all",
        "history":"icon-history",
        "report":"icon-report",
        "alarm":"icon-alarm",
        "monitor":"icon-monitor",
        "smartpipe":"icon-pipeline", // 智慧管网
        "decision":"icon-decision", // 决策分析
        "pipesection":"icon-section", // 管段分析
        "gis":"icon-gis" //GIS
    }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router;